import React, { useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import PriceCalendar from './PriceCalendar';
import { inject } from 'mobx-react';
import { T } from '../../helpers/i18n';
var PriceCalendarView = inject('store')(function (props) {
    var store = props.store, stretch = props.stretch, money = props.money;
    var _a = useState(false), reset = _a[0], setReset = _a[1];
    // estado para busy, usado por ejemplo para que no se pueda pulsar dos veces un botón que envía al servidor
    var _b = useState(false), busy = _b[0], setBusy = _b[1];
    // guardo
    var handleSavePrice = function (data) {
        setBusy(true);
        console.log('data: ', data);
        store.datePricesStore.saveDatePrices(data).then(function (value) {
            store.UI.newWarning(T('saved'));
            setReset(true);
            setBusy(false);
        })
            .catch(function (error) {
            store.UI.newError('error guardando');
            setBusy(false);
            console.log('error: ', error);
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, null,
            React.createElement(Row, { className: "justify-content-center" },
                React.createElement(Col, null,
                    React.createElement(PriceCalendar, { stretch: stretch, money: money, reset: reset, busy: busy, 
                        // schedules={mockSchedules}
                        onSavePriceClick: handleSavePrice, onReseted: function () {
                            setReset(false);
                        } }))))));
});
export default PriceCalendarView;



//////////////////
// WEBPACK FOOTER
// ./src/components/PriceCalendar/PriceCalendarView.tsx
// module id = 1542
// module chunks = 0